import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import ApartmentOutlined from '@ant-design/icons-svg/es/asn/ApartmentOutlined';
import AppstoreOutlined from '@ant-design/icons-svg/es/asn/AppstoreOutlined';
import ArrowLeftOutlined from '@ant-design/icons-svg/es/asn/ArrowLeftOutlined';
import ArrowUpOutlined from '@ant-design/icons-svg/es/asn/ArrowUpOutlined';
import BarChartOutlined from '@ant-design/icons-svg/es/asn/BarChartOutlined';
import BarsOutlined from '@ant-design/icons-svg/es/asn/BarsOutlined';
import ClusterOutlined from '@ant-design/icons-svg/es/asn/ClusterOutlined';
import DatabaseOutlined from '@ant-design/icons-svg/es/asn/DatabaseOutlined';
import DoubleLeftOutlined from '@ant-design/icons-svg/es/asn/DoubleLeftOutlined';
import DoubleRightOutlined from '@ant-design/icons-svg/es/asn/DoubleRightOutlined';
import DownOutlined from '@ant-design/icons-svg/es/asn/DownOutlined';
import EditOutlined from '@ant-design/icons-svg/es/asn/EditOutlined';
import FileExcelOutlined from '@ant-design/icons-svg/es/asn/FileExcelOutlined';
import FileTextOutlined from '@ant-design/icons-svg/es/asn/FileTextOutlined';
import FundProjectionScreenOutlined from '@ant-design/icons-svg/es/asn/FundProjectionScreenOutlined';
import HistoryOutlined from '@ant-design/icons-svg/es/asn/HistoryOutlined';
import IdcardOutlined from '@ant-design/icons-svg/es/asn/IdcardOutlined';
import InboxOutlined from '@ant-design/icons-svg/es/asn/InboxOutlined';
import InfoCircleOutlined from '@ant-design/icons-svg/es/asn/InfoCircleOutlined';
import KeyOutlined from '@ant-design/icons-svg/es/asn/KeyOutlined';
import LeftOutlined from '@ant-design/icons-svg/es/asn/LeftOutlined';
import LineChartOutlined from '@ant-design/icons-svg/es/asn/LineChartOutlined';
import LinkOutlined from '@ant-design/icons-svg/es/asn/LinkOutlined';
import LockOutlined from '@ant-design/icons-svg/es/asn/LockOutlined';
import LoginOutlined from '@ant-design/icons-svg/es/asn/LoginOutlined';
import LogoutOutlined from '@ant-design/icons-svg/es/asn/LogoutOutlined';
import MailOutlined from '@ant-design/icons-svg/es/asn/MailOutlined';
import MenuOutlined from '@ant-design/icons-svg/es/asn/MenuOutlined';
import MessageOutlined from '@ant-design/icons-svg/es/asn/MessageOutlined';
import NodeIndexOutlined from '@ant-design/icons-svg/es/asn/NodeIndexOutlined';
import PieChartOutlined from '@ant-design/icons-svg/es/asn/PieChartOutlined';
import PlusOutlined from '@ant-design/icons-svg/es/asn/PlusOutlined';
import PlusSquareOutlined from '@ant-design/icons-svg/es/asn/PlusSquareOutlined';
import ProfileOutlined from '@ant-design/icons-svg/es/asn/ProfileOutlined';
import ProjectOutlined from '@ant-design/icons-svg/es/asn/ProjectOutlined';
import QuestionCircleOutlined from '@ant-design/icons-svg/es/asn/QuestionCircleOutlined';
import RightOutlined from '@ant-design/icons-svg/es/asn/RightOutlined';
import RiseOutlined from '@ant-design/icons-svg/es/asn/RiseOutlined';
import SafetyCertificateOutlined from '@ant-design/icons-svg/es/asn/SafetyCertificateOutlined';
import SearchOutlined from '@ant-design/icons-svg/es/asn/SearchOutlined';
import SendOutlined from '@ant-design/icons-svg/es/asn/SendOutlined';
import SmileOutlined from '@ant-design/icons-svg/es/asn/SmileOutlined';
import TagsOutlined from '@ant-design/icons-svg/es/asn/TagsOutlined';
import TeamOutlined from '@ant-design/icons-svg/es/asn/TeamOutlined';
import ThunderboltOutlined from '@ant-design/icons-svg/es/asn/ThunderboltOutlined';
import TwitterOutlined from '@ant-design/icons-svg/es/asn/TwitterOutlined';
import UnlockOutlined from '@ant-design/icons-svg/es/asn/UnlockOutlined';
import UnorderedListOutlined from '@ant-design/icons-svg/es/asn/UnorderedListOutlined';
import UserOutlined from '@ant-design/icons-svg/es/asn/UserOutlined';
import UserSwitchOutlined from '@ant-design/icons-svg/es/asn/UserSwitchOutlined';
import WechatOutlined from '@ant-design/icons-svg/es/asn/WechatOutlined';
import WifiOutlined from '@ant-design/icons-svg/es/asn/WifiOutlined';
import XOutlined from '@ant-design/icons-svg/es/asn/XOutlined';

type AntIconDefinition = {
  icon: {
    tag: string;
    attrs: Record<string, string>;
    children?: AntIconDefinition['icon'][];
  };
};

const iconMap: Record<string, AntIconDefinition> = {
  activity: ThunderboltOutlined,
  'arrow-left': ArrowLeftOutlined,
  'arrow-up-short': ArrowUpOutlined,
  'bar-chart': BarChartOutlined,
  'bar-chart-line': LineChartOutlined,
  broadcast: WifiOutlined,
  'box-arrow-in-right': LoginOutlined,
  'box-arrow-right': LogoutOutlined,
  'chat-square-text': MessageOutlined,
  'chevron-double-left': DoubleLeftOutlined,
  'chevron-double-right': DoubleRightOutlined,
  'chevron-down': DownOutlined,
  'chevron-left': LeftOutlined,
  'chevron-right': RightOutlined,
  'clipboard-data': ProfileOutlined,
  database: DatabaseOutlined,
  'diagram-2': ClusterOutlined,
  'diagram-3': ApartmentOutlined,
  'emoji-smile': SmileOutlined,
  envelope: MailOutlined,
  'file-earmark-spreadsheet': FileExcelOutlined,
  graph: RiseOutlined,
  'graph-up': RiseOutlined,
  grid: AppstoreOutlined,
  inbox: InboxOutlined,
  'info-circle': InfoCircleOutlined,
  journal: FileTextOutlined,
  'journal-text': FileTextOutlined,
  kanban: ProjectOutlined,
  key: KeyOutlined,
  link: LinkOutlined,
  'link-45deg': LinkOutlined,
  list: MenuOutlined,
  'list-task': UnorderedListOutlined,
  lock: LockOutlined,
  map: FundProjectionScreenOutlined,
  'node-plus': NodeIndexOutlined,
  pencil: EditOutlined,
  'pencil-square': EditOutlined,
  people: TeamOutlined,
  person: UserOutlined,
  'person-badge': IdcardOutlined,
  'person-lines-fill': UserSwitchOutlined,
  'plus-lg': PlusOutlined,
  'plus-square': PlusSquareOutlined,
  'question-circle': QuestionCircleOutlined,
  search: SearchOutlined,
  'send-check': SendOutlined,
  'shield-check': SafetyCertificateOutlined,
  'shield-lock': LockOutlined,
  tags: TagsOutlined,
  twitter: TwitterOutlined,
  unlock: UnlockOutlined,
  wechat: WechatOutlined,
  x: XOutlined,
};

function createIconElement(definition: AntIconDefinition['icon']): SVGElement {
  const element = document.createElementNS('http://www.w3.org/2000/svg', definition.tag);
  for (const [key, value] of Object.entries(definition.attrs || {})) {
    element.setAttribute(key, value);
  }
  for (const child of definition.children || []) {
    element.append(createIconElement(child));
  }
  return element;
}

function mountAntIcons() {
  document.querySelectorAll<HTMLElement>('i.bi').forEach((node) => {
    const iconClass = Array.from(node.classList).find((className) => className.startsWith('bi-'));
    const iconName = iconClass?.replace(/^bi-/, '');
    const definition = iconName ? iconMap[iconName] : null;
    if (!definition) return;

    const svg = createIconElement(definition.icon);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('height', '1em');
    svg.setAttribute('width', '1em');

    node.classList.add('zhibi-ant-icon');
    node.setAttribute('aria-hidden', 'true');
    node.replaceChildren(svg);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeShell);
} else {
  initializeShell();
}

function initializeShell() {
  mountAntIcons();
  bindSidebarToggle();
  bindBackToTop();
  bindFormValidation();
  enhanceLegacyTables();
}

function bindSidebarToggle() {
  document.querySelectorAll<HTMLElement>('.toggle-sidebar-btn').forEach((button) => {
    button.addEventListener('click', () => {
      document.body.classList.toggle('toggle-sidebar');
    });
  });
}

function bindBackToTop() {
  const backToTop = document.querySelector<HTMLElement>('.back-to-top');
  if (!backToTop) return;

  const toggleBackToTop = () => {
    backToTop.classList.toggle('active', window.scrollY > 100);
  };
  window.addEventListener('load', toggleBackToTop);
  document.addEventListener('scroll', toggleBackToTop);
}

function bindFormValidation() {
  document.querySelectorAll<HTMLFormElement>('.needs-validation').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    });
  });
}

function enhanceLegacyTables() {
  document.querySelectorAll<HTMLTableElement>('table[data-zhibi-table]').forEach((table) => {
    const tbody = table.tBodies[0];
    if (!tbody) return;

    const rows = Array.from(tbody.rows);
    if (rows.length === 0) return;

    const pageSizeOptions = [5, 10, 20, 50];
    let pageSize = Number(table.dataset.pageSize || 10);
    let page = 1;
    let filterText = '';

    const controls = document.createElement('div');
    controls.className = 'zhibi-table-controls';
    controls.innerHTML = `
      <label class="zhibi-table-filter">
        <span>筛选</span>
        <input type="search" class="form-control form-control-sm" placeholder="输入关键词">
      </label>
      <div class="zhibi-table-pager">
        <span class="zhibi-table-status"></span>
        <button type="button" class="zhibi-table-page-button" data-action="prev">上一页</button>
        <button type="button" class="zhibi-table-page-button" data-action="next">下一页</button>
        <select class="form-select form-select-sm zhibi-table-page-size" aria-label="每页显示条数">
          ${pageSizeOptions.map((size) => `<option value="${size}">${size} 条/页</option>`).join('')}
        </select>
      </div>
    `;

    const wrapper = table.closest('.zhibi-table-wrapper') || table;
    wrapper.insertAdjacentElement('afterend', controls);

    const input = controls.querySelector<HTMLInputElement>('input');
    const status = controls.querySelector<HTMLElement>('.zhibi-table-status');
    const prevButton = controls.querySelector<HTMLButtonElement>('[data-action="prev"]');
    const nextButton = controls.querySelector<HTMLButtonElement>('[data-action="next"]');
    const pageSizeSelect = controls.querySelector<HTMLSelectElement>('.zhibi-table-page-size');
    if (!input || !status || !prevButton || !nextButton || !pageSizeSelect) return;

    pageSizeSelect.value = String(pageSizeOptions.includes(pageSize) ? pageSize : 10);
    pageSize = Number(pageSizeSelect.value);

    const render = () => {
      const matchedRows = rows.filter((row) => row.innerText.toLowerCase().includes(filterText));
      const totalPages = Math.max(1, Math.ceil(matchedRows.length / pageSize));
      page = Math.min(page, totalPages);
      const start = (page - 1) * pageSize;
      const visibleRows = new Set(matchedRows.slice(start, start + pageSize));

      rows.forEach((row) => {
        row.hidden = !visibleRows.has(row);
      });

      const startLabel = matchedRows.length === 0 ? 0 : start + 1;
      const endLabel = Math.min(start + pageSize, matchedRows.length);
      status.textContent = matchedRows.length > 0
        ? `显示 ${startLabel}-${endLabel} 条，共 ${matchedRows.length} 条`
        : '无匹配结果';
      prevButton.disabled = page <= 1;
      nextButton.disabled = page >= totalPages;
    };

    input.addEventListener('input', () => {
      filterText = input.value.trim().toLowerCase();
      page = 1;
      render();
    });
    prevButton.addEventListener('click', () => {
      page -= 1;
      render();
    });
    nextButton.addEventListener('click', () => {
      page += 1;
      render();
    });
    pageSizeSelect.addEventListener('change', () => {
      pageSize = Number(pageSizeSelect.value);
      page = 1;
      render();
    });

    render();
  });
}
